/**
 * Pure text-extraction helpers for chat messages, kept dependency-light so
 * they can be unit-tested without the chat component's `useChat` stack.
 */

/** Concatenate the text of all `type: "text"` parts; "" for non-array input. */
export function extractTextFromParts(ps: unknown): string {
  if (!Array.isArray(ps)) {
    return "";
  }
  return ps
    .filter((p: Record<string, unknown>) => p.type === "text" && p.text)
    .map((p: Record<string, unknown>) => p.text)
    .join("");
}

/**
 * Recover a message's plain text across both serialization shapes.
 *
 * Live/streamed messages are `parts`-shaped (AI SDK `UIMessage`). But
 * `buildUiHistory` (lib/systems/narrator.ts) emits `USER_INPUT` history
 * messages — including the injected nudge — `content`-only, with no `parts`.
 * Prefer `parts`; fall back to string `content`; otherwise "".
 */
export function messageText(m: { parts?: unknown; content?: unknown }): string {
  if (Array.isArray(m.parts)) {
    return extractTextFromParts(m.parts);
  }
  if (typeof m.content === "string") {
    return m.content;
  }
  return "";
}
